module.exports = __webpack_public_path__ + "img/network.7a7807a9.jpg";